module.exports = __webpack_public_path__ + "img/8.1281f992.jpg";